// extracted by mini-css-extract-plugin
module.exports = {"img-preview":"styles_img-preview__2jxuF"};